import React, { useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { useData } from "../../../components/firebase/DataProvider";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Typography from "@material-ui/core/Typography";
import AlamatDialog from "../Alamat/AlamatDialog";
import { DialogTitle, IconButton } from "@material-ui/core";

function ListAlamat({ open, handleClose }) {
  const { alamat, profil } = useData();
  const [dialog, setDialog] = useState({
    open: false,
    action: "",
    data: {},
  });

  return (
    <>
      <Dialog
        // fullWidth
        // maxWidth="md"
        open={open}
        onClose={handleClose}
        fullScreen
        PaperProps={{
          style: { maxWidth: 960 },
        }}
        // classes={{
        //   paperFullWidth: classes.fullWidth,
        //   paperScrollPaper: classes.paper,
        //   paper: classes.root,
        //   root: classes.root,
        // }}
      >
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={handleClose}
              style={{ marginRight: 15 }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography>Edit Alamat</Typography>
          </div>
        </DialogTitle>
        {/* <Header onClick={handleClose} type="with-title" title="Ubah Alamat" /> */}
        <DialogContent dividers style={{ padding: 10 }}>
          <List style={{ padding: 0 }}>
            {alamat?.length > 0 ? (
              alamat?.map((item) => {
                return (
                  <ListItem
                    button
                    onClick={() => {
                      setDialog({
                        open: true,
                        action: "edit",
                        data: item,
                      });
                    }}
                  >
                    <ListItemText
                      primary={
                        <>
                          <Typography
                            style={{ display: "inline" }}
                            color="textPrimary"
                          >
                            {item?.nama_penerima}
                          </Typography>
                          <Typography
                            style={{ display: "inline" }}
                            color="error"
                          >
                            {"     "}{" "}
                            {profil?.alamat_utama === item.id ? "[Utama]" : ""}
                          </Typography>
                        </>
                      }
                      secondary={
                        <React.Fragment>
                          {`${item.alamat_lengkap}, ${item.kecamatan.name}, ${item.kelurahan.name}, ${item.kota.name}`}
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction
                      onClick={() => {
                        setDialog({
                          open: true,
                          action: "edit",
                          data: item,
                        });
                      }}
                    >
                      <IconButton edge="end" aria-label="Edit">
                        <EditIcon />
                      </IconButton>{" "}
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })
            ) : (
              <div>
                <p>Tidak ada data</p>
              </div>
            )}
          </List>
          {/* <Gap height={50} /> */}
        </DialogContent>
      </Dialog>
      <AlamatDialog
        open={dialog.open}
        action={dialog.action}
        data={dialog.data}
        handleClose={() =>
          setDialog({
            open: false,
            action: "",
            data: {},
          })
        }
      />
    </>
  );
}

export default ListAlamat;
